export default __webpack_public_path__ + "static/media/arrow.65fe4625.svg";